import createClient, { type Client, type Middleware } from 'openapi-fetch';
import type { paths } from './openapi.js';

export type { paths, components, operations } from './openapi.js';

export interface ApiClientOptions {
  /** Origine de l'API, par exemple https://demo.exemple.pf ; les chemins du contrat commencent par /api/v1. */
  baseUrl: string;
  /** Fournit le jeton d'accès courant (Keycloak). Renvoie null si non connecté. */
  getAccessToken: () => Promise<string | null> | string | null;
  /** Alias de la collectivité visée, pour les comptes membres de plusieurs collectivités. */
  organization?: string;
  fetch?: typeof fetch;
}

export type ApiClient = Client<paths>;

/**
 * Client typé de l'API : chaque route, paramètre et réponse est vérifié à la compilation
 * à partir du contrat OpenAPI produit par l'API elle-même.
 *
 *   const api = createApiClient({ baseUrl, getAccessToken: () => keycloak.token });
 *   const { data, error } = await api.GET('/api/v1/agents');
 */
export function createApiClient(options: ApiClientOptions): ApiClient {
  const client = createClient<paths>({ baseUrl: options.baseUrl, fetch: options.fetch });
  const auth: Middleware = {
    async onRequest({ request }) {
      const token = await options.getAccessToken();
      if (token) request.headers.set('Authorization', `Bearer ${token}`);
      if (options.organization) request.headers.set('X-Organization', options.organization);
      return request;
    },
  };
  client.use(auth);
  return client;
}
